namespace RioERP.Users {
    export interface SendWhatsAppResponse extends Serenity.ServiceResponse {
        ErrorList?: string[];
        Inserted?: number;
    }
}
